import { HttpContextToken } from '@angular/common/http';

export const WithPrincipal = new HttpContextToken(() => false);
